import type { LearnerProfile_LearningGoal as LearningGoal } from '__generated__/graphql-types';
import type { Skill_CareerRole } from '__generated__/graphql-types-do-not-use';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import indefiniteArticle from 'indefinite-article';

import type { LearnerProfileRole } from 'bundles/page-config-common/contexts/consumer/LearnerProfileContext';

import _t from 'i18n!nls/consumer-home';

type GetCoachOnboardingCopyParams = {
  goal?: LearningGoal;
  roles?: Array<LearnerProfileRole>;
  interestedDomains?: Array<string>;
  hasCompletedPathway?: boolean;
  inferredRole?: Pick<Skill_CareerRole, 'id' | 'name' | 'slug'>;
  shouldShowOnboardingV3?: boolean;
};

export const getCoachOnboardingCopy = ({
  goal,
  roles,
  interestedDomains,
  hasCompletedPathway,
  inferredRole,
  shouldShowOnboardingV3,
}: GetCoachOnboardingCopyParams) => {
  if (shouldShowOnboardingV3) {
    const hasRoles = roles && roles.length > 0;
    const hasInterestedDomains = interestedDomains && interestedDomains.length > 0;

    if (inferredRole) {
      return {
        text: _t(
          'Interested in #{article} <strong>#{name}</strong> role? Set it as your role to get personalized recommendations.',
          {
            article: indefiniteArticle(inferredRole.name),
            name: inferredRole.name,
          }
        ),
        cta: _t('Set my role'),
      };
    } else if (!hasRoles && !hasInterestedDomains) {
      return {
        text: _t("Add your interests and we'll share personalized recommendations to help you achieve your goals."),
        cta: _t('Edit your interests'),
      };
    } else if (!hasRoles) {
      return {
        text: _t("Add roles you're interested in and we'll recommend courses to help you achieve your goals."),
        cta: _t('Edit your interests'),
      };
    } else {
      return {
        text: undefined,
        cta: undefined,
      };
    }
  }

  if (inferredRole) {
    return {
      text: _t(
        'Interested in becoming #{article} <strong>#{name}</strong>? Set it as your role and get personalized recommendations.',
        {
          article: indefiniteArticle(inferredRole.name),
          name: inferredRole.name,
        }
      ),
      cta: _t('Yes, set my role'),
    };
  }

  // if in completed state
  else if (hasCompletedPathway && goal && roles && roles.length > 0) {
    return {
      text: _t('Did you achieve your goal?'),
      cta: _t('Set a new career goal'),
    };
  }

  // if no goal but roles are set
  else if (!goal && roles && roles.length > 0) {
    return {
      text: _t("Let's get started! What's your goal?"),
      cta: _t('Select a goal'),
    };
  }

  // if goal but no roles are set
  else if (goal && (!roles || roles.length === 0)) {
    return {
      text: _t("Let's get started! Which role(s) are you interested in?"),
      cta: _t('Select role'),
    };
  }

  // if no choices made / skipped onboarding
  else if (!goal && (!roles || roles.length === 0)) {
    return {
      text: _t('Need help? Tell me a little about yourself so I can make the best recommendations.'),
      cta: _t('Set your goal'),
    };
  } else {
    return {
      text: undefined,
      cta: undefined,
    };
  }
};
